<template>
  <section class="admin-content" id="contact-search">
    <Navbar/>
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center" style="gap: 16px;">
              <div class="header-icon-wrap">
                <i class="fe fe-briefcase" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Agencies</h4>
                <small style="opacity: 0.8;">{{ agencies.length || 0 }} agency subscription(s)</small>
              </div>
            </div>
            <button class="btn btn-outline-light btn-sm" @click="show = !show">
              <i class="fe mr-1" :class="show ? 'fe-x' : 'fe-plus'"></i>
              {{ show ? 'Cancel' : 'Add Agency' }}
            </button>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Add Agency Form ── -->
        <div class="card shadow-sm form-card mb-4" v-show="show">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-briefcase"></i></div>
            <h6 class="mb-0 font-weight-bold text-white">Add Agency</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label class="small font-weight-bold text-secondary">Agency</label>
                <select class="form-control" v-model="agency_id">
                  <option id="Parent" v-for="hmo in hmos" v-bind:key="hmo.id" :value="hmo.id">{{ hmo.agency_name }}</option>
                </select>
              </div>
            </div>
            <button class="btn btn-submit px-4" @click="addAgency">
              <i class="fe fe-send mr-2"></i> Submit
            </button>
          </div>
        </div>

        <!-- ── Agencies Table ── -->
        <div class="card shadow table-card">
          <div class="d-flex align-items-center px-4 pt-4 pb-3">
            <i class="fe fe-briefcase text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold">Agencies</h6>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th px-4">Agency</th>
                  <th class="table-th">Phone Number</th>
                  <th class="table-th">Status</th>
                  <th class="table-th"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="agency in agencies" v-bind:key="agency.id" class="table-row">
                  <td class="px-4 py-3 font-weight-bold" style="font-size: 0.85rem;">{{ agency.agency_name }}</td>
                  <td class="py-3" style="font-size: 0.85rem;">{{ agency.phone_number }}</td>
                  <td class="py-3">
                    <span v-if="agency.status == 1" class="status-badge status-badge--approved">approved</span>
                    <span v-if="agency.status == 0" class="status-badge status-badge--pending">pending</span>
                  </td>
                  <td class="py-3">
                    <a href="#" class="btn btn-outline-secondary btn-sm mr-1"><i class="fe fe-edit-2"></i></a>
                    <a href="#" class="btn btn-outline-secondary btn-sm"><i class="fe fe-eye"></i></a>
                  </td>
                </tr>
                <tr v-if="!agencies || !agencies.length">
                  <td colspan="4" class="text-center py-5 text-muted">
                    <i class="fe fe-briefcase" style="font-size: 2rem; opacity: 0.3;"></i>
                    <p class="mt-2 mb-0">No agencies found</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading"
          loader="dots"
          :can-cancel="true"
          :is-full-page="fullPage"></loading>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin


export default {
  components: {
     Navbar, Loading
  },
  data(){
    return{
      user:null,
      show:false,
      hmos:"",
      agencies:"",
      edit:false,
      isLoading: false,
      fullPage: true,
      agency_id:""
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))

    this.axios.get(`/api/v1/auth/allHmo`)
                .then(response => {
                    this.hmos = response.data.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{
    getHmo(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/hmoProvider/${this.user.id}`)
                  .then(response => {
                      this.agencies = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },

    addAgency(){

      this.user = JSON.parse(localStorage.getItem('user'))

      if (this.edit === false) {
      // Add dependent
      this.isLoading = true;
      this.axios.post('/api/v1/auth/providerApply',{

        provider_id: this.user.id,
        agency_id: this.agency_id,
        status: false,
      })

      .then(response=>{
          console.log(response);
          this.clearIt();
          this.getHmo();
          this.isLoading = false;
          this.$breadstick.notify("Agency added Successfully!", {position: "top-right"});


      })
      .catch(error=>{
          console.log(error.response)
      })
      }else {
      // Update
      this.isLoading = true;
      this.axios.put('/api/v1/auth/addDependant',{

        topic_id: this.topic.id,
        topic_name: this.topic.topic_name,
        // module_id: this.course.id,
        module_id: this.$route.params.id,
        topic_content: this.topic.topic_content,
        video: this.topic.video,
        audio: this.audio,
        doc: this.doc,

      })

      .then(response=>{
          console.log(response);
          this.clearIt();
          this.fetchModule();
          this.edit = true;
          this.isLoading = false;
          this.$toasted.global.crudUpdated().goAway(1500);

      })
      .catch(error=>{
          console.log(error.response)
      })

      }
    },

    clearIt(){

      this.agency_id = "";

    },

  },
  created(){
    this.getHmo()
  }

}
</script>
